import Cookies from "js-cookie"
import React, { Suspense, lazy } from "react"
import { Navigate, Route, Routes, useLocation } from "react-router-dom"

import GlobalLoader from "shared/components/Loader/Global"
import LocalLoader from "shared/components/Loader/Local"
import LayoutCommon from "shared/layouts/Common/Common"
import dayjs from "shared/services/date"
import Auth from "views/Auth"

const TermsAndConditions = lazy(() =>
  import("../views/TermsAndConditions/TermsAndConditions")
)
const SignUp = lazy(() => import("../views/SignUp/SignUp"))
const EmailForm = lazy(() =>
  import("../views/PasswordReset/views/EmailForm/EmailForm")
)
const NewPasswordForm = lazy(() =>
  import("../views/PasswordReset/views/NewPasswordForm/NewPasswordForm")
)

const notSignedInPaths = [
  "/",
  "/login",
  "/terms-and-conditions/wi",
  "/sign-up",
  "/password-reset/submit-email",
  "/password-reset/submit-password",
]

export default function PublicRoutes(props) {
  const { isLoading } = props
  const location = useLocation()
  const redirectTo = Cookies.get("redirectTo")

  if (!redirectTo && !notSignedInPaths.includes(location.pathname)) {
    const expires = new Date(dayjs().add(30, "second").toString())
    Cookies.set("redirectTo", location.pathname + location.search, {
      expires,
    })
  }

  return isLoading ? (
    <GlobalLoader floating={false} />
  ) : (
    <Routes location={location}>
      <Route element={<LayoutCommon />}>
        <Route path="/" element={<Auth />} />
        <Route path="login" element={<Auth />} />
        <Route
          path="terms-and-conditions/*"
          element={
            <Suspense fallback={<LocalLoader />}>
              <TermsAndConditions />
            </Suspense>
          }
        />
        <Route
          path="sign-up"
          element={
            <Suspense fallback={<LocalLoader />}>
              <SignUp />
            </Suspense>
          }
        />
        <Route
          path="password-reset/submit-email"
          element={
            <Suspense fallback={<LocalLoader />}>
              <EmailForm />
            </Suspense>
          }
        />
        <Route
          path="password-reset/submit-password"
          element={
            <Suspense fallback={<LocalLoader />}>
              <NewPasswordForm />
            </Suspense>
          }
        />
        <Route path="*" element={<Navigate to="/login" />} />
      </Route>
    </Routes>
  )
}
